import { Hub } from '../model/entities';
import providerAuthService from '../services/ProviderAuthService';
import { proxyApiAxios } from './CustomAxios';

class HubApi {
    list = async (application?: boolean): Promise<Hub[]> => {
        const requestBody = await providerAuthService.getAccessTokens();
        const response = await proxyApiAxios.post<Hub[]>('/hubs', requestBody, {
            params: { application },
        });
        return response.data;
    };
}

const hubApi: HubApi = new HubApi();
export default hubApi;
